import { AbstractReportPmsApiService } from '../abstract-report.service';
import { FrontDeskNoShowReport } from '../../../models/reports/front-desk/no-show-report.model';

/**
 * @class FrontDeskNoShowReportPmsApiService
 * @extends {AbstractReportPmsApiService<FrontDeskNoShowReport>}
 */
export class FrontDeskNoShowReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/front-desk/no-show';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {FrontDeskNoShowReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new FrontDeskNoShowReport(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/front-desk/no-show-report.service.js